import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import useAuth from '../../auth/useAuth';
import { generalInfoQuery, scenarioLevelsQuery } from './api';
import TutorialElements from './tutorial-elements';
import TutorialDefault from './tutorial-default';
import TutorialScramble from './tutorial-scramble';
import TutorialMultiStep from './tutorial-multistep';


const tutorialComponents = {
  'class-elements': TutorialElements,
  'class-default': TutorialDefault,
  'class-tricky': TutorialDefault,
  'classified-multistep': TutorialMultiStep,
  'scramble': TutorialScramble
};

// Realco level names follow the `real-public-co-<DisplayName>`
// convention. They share the multistep gameplay, so they share the
// multistep tutorial too.
const REALCO_PREFIX = 'real-public-co';

const resolveTutorialComponent = (levelName) => {
  if (levelName?.startsWith(REALCO_PREFIX)) return TutorialMultiStep;
  return tutorialComponents[levelName] || TutorialElements;
};

export default function NormalRouterTutorial() {
  const params = useParams();
  const levelNumber = Number(params.levelNumber);

  const { getCurrentClassificationGameId } = useAuth();
  const gameId = getCurrentClassificationGameId();

  const { data: generalInfo, isLoading: gamesLoading } = useQuery(generalInfoQuery());
  const games = generalInfo?.games;

  const game = games?.find(game => game.id === gameId);
  const scenarioId = game?.scenario;

  const { data: scenarioLevels, isLoading: levelsLoading } = useQuery({
    ...scenarioLevelsQuery({ scenarioId }),
    enabled: !!scenarioId,
  });

  if (gamesLoading || !scenarioId || levelsLoading) {
    return null;
  }

  const currentLevel = scenarioLevels?.find(
    scenarioLevel => scenarioLevel.level === levelNumber
  );

  const TutorialComponent = resolveTutorialComponent(currentLevel?.name);

  return <TutorialComponent key={levelNumber} levelNumber={levelNumber} />;
}